import { render, staticRenderFns } from "./BranchTable.vue?vue&type=template&id=24d9fa30&"
import script from "./BranchTable.vue?vue&type=script&lang=js&"
export * from "./BranchTable.vue?vue&type=script&lang=js&"
import style0 from "./BranchTable.vue?vue&type=style&index=0&id=24d9fa30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports